import styled from 'styled-components';

export const ActionContainer = styled.div`
  ${props => props.verticalCenter && 'display: flex; align-items: center;'}
`;
